import PropTypes from "prop-types";
import { forwardRef } from "react";
import { Button as MuiButton } from "@mui/material";
import "./styles.scss";

const Button = forwardRef(({ className = "", ...props }, ref) => {
  return <MuiButton ref={ref} className={`ui_button ${className}`} {...props} />;
});

Button.displayName = "Button";

Button.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  variant: PropTypes.oneOf(["text", "outlined", "contained"]),
  color: PropTypes.oneOf(["inherit", "primary", "secondary", "success", "error", "info", "warning"]),
  size: PropTypes.oneOf(["small", "medium", "large"]),
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  type: PropTypes.oneOf(["button", "submit", "reset"]),
  fullWidth: PropTypes.bool,
  href: PropTypes.string,
  startIcon: PropTypes.node,
  endIcon: PropTypes.node
};

export default Button;
